import * as React from 'react';
import HtmlParser from 'html-react-parser';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { SurveyStep } from '../../models';
import { ActionCreators as SurveyBuilderActionCreators } from '../../store/SurveyBuilderStore';
import { BodyCopyLink, InstructionsContainer, InstructionsText, InstructionsTitle } from '../common/styles/globalStyles';

const ContentContainer = styled.div`
	text-align: center;
	position: relative;
	margin-top: 125px;
	margin-bottom: 105px @media (min-width: 0) and (max-width: 768px) {
		margin-top: 105px;
		margin-bottom: 85px;
	}
`;
ContentContainer.displayName = 'ContentContainer';

export const NoAudienceSource = () => {
	const dispatch = useDispatch();

	return (
		<ContentContainer>
			<InstructionsContainer>
				<InstructionsTitle>{ContentConstants.AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTITLE}</InstructionsTitle>
				<InstructionsText>
					{HtmlParser(ContentConstants.AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTEXT)}
					<BodyCopyLink onClick={() => dispatch(SurveyBuilderActionCreators.Jump(SurveyStep.Basics))}>
						{ContentConstants.AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSLINKTEXT}
					</BodyCopyLink>
					{ContentConstants.AUDIENCELIST_NOAUDIENCESOURCE_INSTRUCTIONSTEXT2}
				</InstructionsText>
			</InstructionsContainer>
		</ContentContainer>
	);
};
